/**
 * This file is called `styled` not `styled-components` so there is no conflict between the module and this file
 */

/**
 * Sometimes there are props which have a valid HTML attribute name but are we do not want them to be passed through
 * to the DOM element. An example of this is `width` when IHasWidth is used as we don't want the object to be output onto
 * the DOM element
 *
 * When this is the case, we need to tell styled component to remove these props. This can be done by adding the
 * following to the styled component
 *
 * `styled.div.withConfig({ shouldForwardProp: shouldForwardProp(['width']) })`
 */
// Update the return type to ShouldForwardProp<'web'> once we update styled-components
export const shouldForwardProp =
  <T>(propsToExclude: keyof T | Array<keyof T>): any =>
  (prop, defaultValidatorFn) =>
    !(Array.isArray(propsToExclude) ? propsToExclude : [propsToExclude]).includes(prop as keyof T) &&
    defaultValidatorFn(prop);
